@if (validTransaction()) {
  <div class="h-full overflow-y-auto">
    <div class="bg-gray-100 border-gray-300 border-b w-full">
      <div
        class="md:flex md:mx-auto px-5 md:px-20 py-7 md:py-14 md:pb-7 3xl:pb-14 w-full md:max-w-max">
        <div class="md:mr-10 md:w-352 text-gray-700 text-center">
          <h2 class="text-base md:text-3xl">Summary</h2>
          <h1 class="lg:text-4xl 3xl:text-5xl">Thanks for your purchase</h1>
        </div>
      </div>
    </div>

    <div
      class="lg:flex lg:mx-auto px-5 md:px-20 py-7 lg:py-14 lg:pt-7 3xl:pt-14 w-full lg:max-w-max">
      <div class="mb-5 lg:w-1/2 2xl:w-176">
        <h3 class="mb-4 font-bold text-main-dark md:text-left text-center">
          Your Order Details
        </h3>

        <!-- DATA BOX -->
        <app-data-box
          [transaction]="transaction()!"
          [isTicketFeeEnabled]="isTicketFeeEnabled()" />
      </div>

      <div class="md:ml-8 2xl:ml-10 w-full lg:w-1/2">
        <h3
          class="mb-4 font-bold text-red text-base md:text-lg md:text-left text-center">
          You might also be interested in:
        </h3>

        <div
          class="flex flex-wrap justify-center -mx-4 xl:h-[90%] text-white text-center">
          <!-- ADLINK -->
          @if (summaryLink()?.link) {
            <span class="p-4 w-60 lg:w-1/2 2xl:w-1/3 aspect-[9/12]">
              <a
                [href]="summaryLink()?.link"
                target="_blank"
                class="flex flex-col justify-between items-center bg-main-dark shadow-lg mb-5 lg:mb-0 p-3 2xl:p-5 w-full h-full text-white box-white">
                <div>
                  @if (summaryLink()?.urlImage) {
                    <img
                      [ngSrc]="summaryLink()!.urlImage"
                      class="m-auto mb-2 max-h-32"
                      [alt]="summaryLink()?.title"
                      width="130"
                      height="130"
                      [priority]="false" />
                  }
                  <div class="m-auto">
                    <p class="mb-2 max-h-14 overflow-y-auto font-normal">
                      {{ summaryLink()?.title }}
                    </p>
                  </div>
                </div>
                <div class="flex flex-col items-center mb-3">
                  <hr class="opacity-20 mb-4 border-white w-24" />
                  <h4 class="font-bold">{{ summaryLink()?.name }}</h4>
                </div>
              </a>
            </span>
          }

          <span
            [hidden]="!configurationService.configuration.mlbShopUrl"
            class="p-4 w-60 lg:w-1/2 2xl:w-1/3 aspect-[9/12]">
            <a
              [href]="configurationService.configuration.mlbShopUrl"
              target="_blank"
              class="flex flex-col justify-between items-center shadow-lg mb-5 lg:mb-0 p-3 2xl:p-5 w-full h-full text-main-dark box-white">
              <div class="m-auto">
                <img
                  alt="mechandise t-shirts image"
                  [ngSrc]="
                    configurationService.configuration.summaryPage.image1
                  "
                  [priority]="false"
                  height="184"
                  width="184" />
              </div>
              <div class="flex flex-col items-center mb-3">
                <hr class="mb-4 w-24" />
                <h4 class="font-bold">
                  {{ configurationService.configuration.clientName }}
                  Merchandise
                </h4>
              </div>
            </a>
          </span>

          <span
            [hidden]="!configurationService.configuration.merchandiseWebUrl"
            class="p-4 w-60 lg:w-1/2 2xl:w-1/3 aspect-[9/12]">
            <a
              [href]="configurationService.configuration.merchandiseWebUrl"
              target="_blank"
              class="flex flex-col justify-between items-center shadow-lg mb-5 lg:mb-0 w-full h-full overflow-hidden text-main-dark box-white"
              [ngStyle]="{
                'background-image':
                  'url(' +
                  configurationService.configuration.summaryPage.image2 +
                  ')'
              }"
              style="
                background-position: -50px center;
                background-repeat: no-repeat;
                background-size: cover;
              ">
              <div
                class="flex flex-col items-center bg-black opacity-60 mt-auto py-3 border-white border-t-2 w-full">
                <h4 class="font-bold text-white">
                  {{ configurationService.configuration.clientName }}
                </h4>
                <h4 class="font-bold text-white">Suites</h4>
              </div>
            </a>
          </span>
        </div>
      </div>
    </div>
  </div>
}
